import { useState, useEffect, Fragment } from 'react';
import {useStripe, useElements, PaymentElement} from '@stripe/react-stripe-js';
import { useTranslation } from 'react-i18next'

// import Loader from '~components/Loader/Loader';
import Loader from '../Loader/Loader';

import { useHookStore } from '../../hook-store/store';
import { 
  getCustomerCardPaymentMethods
} from '../../utils/stripe/payment-method-utils';

// import { 
//   BACKEND_URL,  
// } from '~config/endpoints';
import {
  IMAGEPHOTO_BACKENDURL
} from '../../lib/api';

import classes from './PaymentMethods.module.css';

const returnUrl = 'http://localhost:8504/';


function PaymentSetupForm(props) {

  const { 
    showCardAddedHandler, 
    showCardInputHandler,
    setShowPaymentSetup,
  } = props;

  const [t] = useTranslation('translation');

  const stripe = useStripe();
  const elements = useElements();

  const [store, dispatch] = useHookStore();
  // const { freeSizeGB } = store.bucketObjectStore;
  const { 
    // usageBasedPrice,
    // usageBasedSubscription,
    // customerMethods,
  } = store.stripeData;
  const { gLoading } = store.uiStore;

  const [errorMessage, setErrorMessage] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  // const [error, setError] = useState('');

  useEffect(() => {

  },[]);

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    try {
      setIsLoading(true);
      setErrorMessage('')
      setSuccessMessage('');
      // dispatch('SET_ISSTRIPE_LOADING', true);

      const { setupIntent, error } = await stripe.confirmSetup({
      //`Elements` instance that was used to create the Payment Element
      elements,
      confirmParams: {
        // return_url: 'https://example.com/account/payments/setup-complete',
        return_url: returnUrl,
        // return_url: '',
      },
      redirect: "if_required"  // for not redirect
      });

      console.log(setupIntent);

      if (error) {
        // This point will only be reached if there is an immediate error when
        // confirming the payment. Show error to your customer (for example, payment
        // details incomplete)
        setErrorMessage(error.message);
        // dispatch('SET_ISSTRIPE_LOADING', false);
      } else {
        // Your customer will be redirected to your `return_url`. For some payment
        // methods like iDEAL, your customer will be redirected to an intermediate
        // site first to authorize the payment, then redirected to the `return_url`.
        if (setupIntent && setupIntent.status === "succeeded") {
          // handle success
          await updatePaymentMethodMetadata(setupIntent.payment_method);

          await getPaymentMethodsHandler();

          setSuccessMessage('card add success!');

          setTimeout(() => {
            setShowPaymentSetup(false);
          }, 1000*10)
        }
      }

      setIsLoading(false);

    } catch(err) {
      console.log(err);
      throw err;
    }
  };

    const updatePaymentMethodMetadata = async (paymentMethodId) => {
    try { 
        setIsLoading(true);
        // dispatch('SET_ISSTRIPE_LOADING', true);

        const response = await fetch(IMAGEPHOTO_BACKENDURL + `/payment-method/update-payment-method-metadata`, {
          method: 'PUT',
          headers: {
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json',
            // 'Accept': 'application/json',
          },
          body: JSON.stringify({
            customerId: localStorage.getItem('customerId'),
            paymentMethodId: paymentMethodId,
            metadata: {
              imagePhotoUsageBased: 'card-added',
            },
          }),
        });

        const resData = await response.json();
        console.log(response, resData);
        setIsLoading(false);
        // dispatch('SET_ISSTRIPE_LOADING', false);

        //// show add success result and close input
        // await showCardAddedHandler(resData.paymentMethod);
        // showCardInputHandler();
    } catch(err) {
      console.log(err);
      setIsLoading(false);
      throw err;
      // dispatch('SET_ISSTRIPE_LOADING', false);
    }
  };

  const getPaymentMethodsHandler = async () => {
    try {
      setIsLoading(true);
      // setError('');

      const resData = await getCustomerCardPaymentMethods(
        IMAGEPHOTO_BACKENDURL, 
        localStorage.getItem('token'),
        localStorage.getItem('customerId'),
      );

      // console.log();

      if (resData.data) {
        const usageBasedList = resData.data.filter(method => {
          return method.metadata && method.metadata.imagePhotoUsageBased;
        });

        // console.log(methodList);
        // setCustomerMethods(result.customerMethods);
        // setCustomerMethods(methodList);
        dispatch('SET_CUSTOMERMETHODS', usageBasedList);

        // setDefaultMethod(methodList);

      }
      setIsLoading(false);

    } catch(err) {
      console.log(err);
      setIsLoading(false);
    }
  };

  let paymentSetupFormBody;

  if (!successMessage) {
      paymentSetupFormBody = (
        <form onSubmit={handleSubmit}>
          <PaymentElement />
          <div className={classes.paymentMethodsButtons}>
            <button className='btnBase'
              disabled={!stripe || isLoading}
              onClick={() => {
                setShowPaymentSetup(false);
              }}
            >
              {t('usageBased17', 'Cancel')} 
            </button>
            <button className='btnBase'
            // design="raised" 
              type="submit"
              disabled={!stripe || isLoading}
            >
              {t('usageBased18', 'Add card')} 
            </button>
          </div>
    
          {errorMessage && <div><strong>{errorMessage}</strong></div>}
          {/* {successMessage && <div><strong>{successMessage}</strong></div>} */}
    
          {isLoading && 
            <div 
            // className={classes.setupFormLoader}
            ><Loader />
          </div>
    
          }
        </form>
      )
  }

  if (successMessage) {
    paymentSetupFormBody = (
      <div><strong>{successMessage}</strong></div>
    );
  }


  if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
  }

  return (
    <Fragment>
      <div>{paymentSetupFormBody}</div>
    </Fragment>
  );
}

export default PaymentSetupForm;
